import { useContext, useState, useEffect } from 'react';
import PageContext from "./PageContext";
import { createTheme, TextField, ThemeProvider, Typography } from '@mui/material';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent';
import BannerAlert from './BannerAlertCopy.jsx';
import PageDropdownWithIDs from './PageDropdownWithIDsCopy.jsx'; 
import ExportS3ExcelButton from './ExportS3ExcelButton.jsx';

const theme = createTheme({
    components: {
      MuiTypography: {
        styleOverrides: {
          root: {
            '&.MuiTypography-root': {
              fontFamily: 'Roboto regular, Helvetica, Arial, sans-serif',
              fontSize: '14px',
              fontWeight: '400',
              lineHeight:'24px'
            },
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            "&.MuiInputBase-input": {
              fontFamily: "Roboto medium, Helvetica, Arial, sans-serif",
              fontSize: "16px",
              fontWeight: "400",
              color:"gray"
            },
          },
        },
      },
    },
  });


const ExportTemplateModal = () =>{
    // get context from parent
    const {
        showExportTemplateModal, 
        setShowExportTemplateModal,
        templateType,
        setTemplateType,
        templateTypeData,
        onTemplateExport,
        companyInfo
    } = useContext(PageContext);


    return(
        <> 
            <ThemeProvider theme={theme}>
                <CCOffcanvas
                    title={'Export Template'}
                    show={showExportTemplateModal}
                    onCanvasClose={()=>setShowExportTemplateModal(showExportTemplateModal => showExportTemplateModal = false)}
                    bodyCssClassName="offcanvas-body bg-white p-3"
                    offCanvasClassName='offcanvas-parent-card-30'
                    >
                    <div className="d-flex flex-column h-100">
                      <div>
                        <BannerAlert show={true} type={'info'} disableClose message={'Always download new template file after each successfully processed upload file. Do not change template file name.'}/>
                      </div>
                      <hr className='m-0 mb-4 mt-2'/>
                      {/* choose type of template to export */}
                      <div>
                          <PageDropdownWithIDs width={'100%'} topAlignTypography={true} tag='Template Type' value={templateType} setValue={setTemplateType} list={templateTypeData} valueKey='templatetypedescription' />
                      </div>
                      <div
                        className="d-flex justify-content-end p-3 pe-0 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                      >
                        <ButtonComponent tag={"Cancel"}
                            border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'}
                            onButtonClick={()=>setShowExportTemplateModal(showExportTemplateModal => showExportTemplateModal = false)}
                        />
                        {/* get template from s3 bucket */}
                        <ExportS3ExcelButton color='#000' background='#fcd800' border='#fcd800 1px solid' buttonTitle='Download' 
                          tag={templateType?.filename 
                            ? `${templateType.filename.replace('.xlsx', '')}-${companyInfo?.mastercompanyid || ''}`
                            : 'template'
                          }  
                          getData={onTemplateExport} removeDate={true}/>

                      </div>
                    </div>
                </CCOffcanvas>
            </ThemeProvider>
        </>
    );
}

export default ExportTemplateModal;